<template>
    <section :id="id" :class="{ ...basicClassName }">
        <s-purchasing-version-2
            :purchase-page-c-t-a="purchasePageCTA"
            :version="currentVersion"
            :page="page"
            :slice-settings-name="sliceSettingsName"
        />
    </section>
</template>

<script>
import { mapValues } from 'lodash-es';
import contentMixin from '@core/mixins/content.js';
import purchasing from '@core/mixins/purchasing';
import styleMixin from '@core/mixins/style.js';
import { LOCALE_DEFAULT } from '@model/const/locales.ts';
import SPurchasingVersion2 from './version-2/index.vue';
import mixin from './version-2/mixin.js';

export default {
    name: 'SPurchasingCyberProtect',
    components: {
        SPurchasingVersion2,
    },
    mixins: [contentMixin, styleMixin, purchasing, mixin],
    props: {
        page: {
            type: Object,
            default: null,
        },
        purchasePageCTA: {
            type: Object,
            default: null,
        },
        sliceSettingsName: {
            type: String,
            default: 's-purchasing-cyber-protect',
        },
    },
    data: () => ({
        searchParams: null,
    }),
    computed: {
        slice() {
            return this.$store.state.slices.items?.[this.sliceSettingsName] || {};
        },
        locale() {
            return this.$store.state.geolocation.finalLocale || LOCALE_DEFAULT;
        },
        currentVersion() {
            return this.page?.version || 2;
        },
    },
    async serverPrefetch() {
        await this.$store.dispatch('slices/getSyncedData', { slice: 's-loader', locale: this.locale });
        await this.$store.dispatch('slices/getSyncedData', { slice: 's-data-centers', locale: this.locale });
        await this.$store.dispatch('slices/getSyncedData', { slice: this.sliceSettingsName, locale: this.locale });

        const listCartID = this.slice?.specialOffer?.licenseID || {};
        const listCleverBridgeCartID = mapValues(listCartID, (item) => ({ cleverBridgeCartID: item }));
        const slice = { ...this.slice, ...listCleverBridgeCartID };
        const settings = { ...this.purchasePageCTA, isPurchase: true };

        await this.findCleverBridgeCart(slice, settings);

        const version = `version-${this.currentVersion}`;
        const sAwards = this.slice?.[version]?.['s-awards']?.award_ids || [];
        const expertAwards = this.slice?.[version]?.dictionary?.expert?.awards || [];
        const awardsPromises = [...sAwards, ...expertAwards].map((item) => this.$store.dispatch('awards/getAward', item));
        await Promise.all(awardsPromises);
    },
};
</script>
